import { Skeleton } from '@mui/material'
import { ReactNode, Suspense } from 'react'

interface SuspenseSkeletonProps {
    itemLazy: ReactNode
}

export default function SuspenseSkeleton({ itemLazy }: SuspenseSkeletonProps) {
    return (
        <Suspense fallback={<Skeleton className='m-auto' width={'80%'} height={'100%'} />}>
            {itemLazy}
        </Suspense>
    )
}
